import { render } from "./CreateTicketTecnico.vue?vue&type=template&id=138b34b8"
import script from "./CreateTicketTecnico.vue?vue&type=script&lang=js"
export * from "./CreateTicketTecnico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__